module.exports = __webpack_public_path__ + "img/MESSAGE.7636a310.svg";